import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { BankAccountForm } from './bank-account';

export default function WireAccountForm({ mode, bank, requiredFields, canEdit = true, isOnboarding = false }) {
  const { t } = useTranslation(['onboarding', 'common']);

  const wireSchema = z.object({
    rail: z.string().min(1, t('common:required_field')),
    account_holder_name: z.string().min(1, t('common:required_field')),
    account_holder_type: z.string().min(1, t('common:required_field')),
    routing_number: z
      .string()
      .min(1, t('common:required_field'))
      .regex(/^\d{9}$/, t('rounting_min')),
    account_number: z
      .string()
      .min(1, t('common:required_field'))
      .regex(/^\d+$/, t('common:invalid_characters')),
    account_class: z.string().min(1, t('common:required_field')),
    bank_name: z.string().min(1, t('common:required_field')),
    bank_country: z.string().min(1, t('common:required_field')),
    bank_address: z.string().min(1, t('common:required_field')),
  });

  return (
    <BankAccountForm
      mode={mode}
      bank={{
        rail: 'WIRE',
        account_holder_name: bank?.account_holder_name || '',
        routing_number: bank?.routing_number || '',
        account_number: bank?.account_number || '',
        account_class: bank?.account_class || 'CHECKING',
        bank_name: bank?.bank_name || '',
        bank_country: bank?.bank_country || 'US',
        bank_address: bank?.bank_address || '',
        account_holder_type: bank?.account_holder_type || 'INDIVIDUAL',
        id: bank?.id || '',
      }}
      rail={'WIRE'}
      requiredFields={requiredFields}
      schema={wireSchema}
        canEdit={canEdit}
        isOnboarding={isOnboarding}
    />
  );
}